import { actionTypes } from './action-types';

export const authActions = {
  login: () => ({
    type: actionTypes.LOGIN,
  }),
  logout: (payload: boolean) => ({
    type: actionTypes.LOGOUT,
    payload,
  }),
  newPassword: (payload: boolean) => ({
    type: actionTypes.NEW_PASSWORD_REQUIRED,
    payload,
  }),
  forgetPassword: (payload: boolean) => ({
    type: actionTypes.FORGET_PASSWORD,
    payload,
  }),
};

type Actions = typeof authActions;
export type AuthActions = ReturnType<Actions[keyof Actions]>;
